import React from "react";

export const HotelSectionLinks = ({ scrollToDiv, showSimilar = true }) => {
  return (
    <div className="hw-sticky--scroller">
    <div className="hw-hotel--singleListScroller">
      <div
        className="hw-hotel--singleListScrollerTab"
        onClick={() => {
          scrollToDiv("hotel_select_room");
        }}
      >
        Rooms
      </div>
      <div
        className="hw-hotel--singleListScrollerTab"
        onClick={() => {
          scrollToDiv("hotel_guest_reviews");
        }}
      >
        Reviews
      </div>
      <div
        className="hw-hotel--singleListScrollerTab"
        onClick={() => {
          scrollToDiv("hotel_location");
        }}
      >
        Location
      </div>
      <div
        className="hw-hotel--singleListScrollerTab"
        onClick={() => {
          scrollToDiv("hotel_facilities");
        }}
      >
        Facilities
      </div>
      <div 
        className="hw-hotel--singleListScrollerTab"
        onClick={() => {
          scrollToDiv("hotel_property_policies");
        }}
      >
        Policies
      </div>
      {showSimilar ? (
        <div
          className="hw-hotel--singleListScrollerTab"
          onClick={() => {
            scrollToDiv("similar_properties");
          }}
        >
          Similar Properties
        </div>
      ) : null}
    </div>
    </div>
  );
};
